import { useQuery } from "@tanstack/react-query";
import { Navigate, Outlet } from "react-router-dom";
import { getMe } from "../api/Client";

/**
 * Wraps routes meant for signed-out visitors (landing page, login/signup).
 * Same /me check RequireAuth uses, just the opposite branch: an existing
 * session bounces straight to /learn instead of rendering the page.
 */
export default function RootGate() {
  const { data, isLoading } = useQuery({
    queryKey: ["me"],
    queryFn: getMe,
    refetchOnMount: "always",
  });

  if (isLoading) {
    return null;
  }

  if (data?.loggedIn) {
    return <Navigate to={"/learn"} replace />;
  }

  return <Outlet />;
}
